<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <basic-dialog v-model="dialog" :actionButtons="actionButtons" :loading="saving"
                :title="$t('tenants.edit_tenant')">
    <v-card-text class="scroll-content">
      <v-form ref="form">
        <v-select v-model="tenantPlan" :items="plans" :label="$t('tenants.status')" item-text="label"
                  item-value="value"></v-select>
      </v-form>
    </v-card-text>
  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog";


export default {
  name: 'TenantPlanDialog',
  components: {BasicDialog},
  data() {
    return {
      dialog: false,
      saving: false,
      tenantPlan: 'FREE',
      currentTenant: null,
      actionButtons: {
        cancel: {
          click: this.cancel,
        },
        save: {
          click: this.changePlan,
        }
      }
    };
  },
  computed: {
    plans() {
      return [
        {
          value: 'FREE',
          label: this.$t('tenants.statuses.FREE')
        },
        {
          value: 'PRO',
          label: this.$t('tenants.statuses.PRO')
        },
        {
          value: 'TOTAL',
          label: this.$t('tenants.statuses.TOTAL')
        }
      ];
    }
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    async changePlan() {
      if (!this.$refs.form.validate()) {
        this.showAlert = true;
        return;
      }
      this.saving = true;
      try {
        await this.$adminApi.updateTenantPlan(this.currentTenant.id, this.tenantPlan);
        this.dialog = false;
        this.$showSuccessNotification(this.$t('tenants.tenant_update_success'));
      } catch (err) {
        this.$handleApiError(err, this.$t('tenants.tenant_update_failed'));
      }
      this.saving = false;
    },
    open(tenant) {
      this.dialog = true;
      this.currentTenant = Object.assign({}, tenant);
      this.tenantPlan = tenant.status;
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.currentTenant = null;
        this.tenantPlan = 'FREE';
        this.$emit('on-dismiss');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-content {
  max-height: calc(100vh - 240px);
  overflow: auto;
}

@media screen and (min-width: 600px) {
  .scroll-content {
    max-height: calc(100vh - 300px);
    overflow: auto;
  }
}
</style>
